<template>
  <v-container fluid>
    <master-report-component />
  </v-container>
</template>

<script>
import MasterReportComponent from '../components/MasterReportComponent.vue';

export default {
  name: 'MasterReportView',
  components: {
    MasterReportComponent,
  },
};
</script>
